<template>
  <v-container fluid class="background-profesional-home py-12">
    <div style="height: auto">
      <v-row no-gutters justify="center">
        <v-col
          cols="10"
          lg="10"
          md="10"
          class="d-flex justify-center d-md-block"
        >
          <h1 class="blue_text--text half-underline mb-16 title-font">
            Profesionales <strong class="font-italic">COLUMBIA</strong>
          </h1>
        </v-col>
      </v-row>

      <v-carousel
        height="100%"
        v-model="model"
        :show-arrows="false"
        hide-delimiters
      >
        <v-carousel-item v-for="(item, index) in items" :key="index">
          <v-row
            class="d-flex align-center justify-content-center"
            justify="center"
          >
            <v-col cols="10" class="d-flex justify-center d-md-none">
              <div
                class="d-flex align-center justify-center"
                style="gap: 1rem; padding: 12px"
              >
                <div
                  v-for="(circle, index) in items"
                  :key="index"
                  style="
                    width: 10px;
                    height: 10px;
                    border: 1px solid #07f;
                    border-radius: 50px;
                  "
                  role="button"
                  :class="model === index ? 'circle-blue' : ''"
                  @click="model = index"
                ></div>
              </div>
            </v-col>
            <v-col cols="8" sm="8" md="4" lg="4" style="position: relative">
              <v-img
                :src="item.src"
                :lazy-src="item.src"
                class="d-none d-md-flex"
                @load="loading(item)"
                content-class="position-content-image"
              >
                <v-btn
                  @click="handleCarousel"
                  fab
                  x-large
                  color="white"
                  style="
                    position: absolute;
                    top: calc(50%);
                    transform: translateY(-50%);
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    width="30"
                    height="30"
                    src="@/assets/icons/next-icon-profesional-home.svg"
                  />
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-btn>
              </v-img>
              <v-img
                :src="item.srcMobile"
                :lazy-src="item.srcMobile"
                class="d-flex d-md-none"
                @load="loading(item)"
                content-class="position-content-image"
              >
                <v-btn
                  @click="handleCarousel"
                  fab
                  small
                  color="white"
                  style="
                    position: absolute;
                    top: calc(50%);
                    transform: translateY(-50%);
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    width="15"
                    height="15"
                    src="@/assets/icons/next-icon-profesional-home.svg"
                  />
                </v-btn>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div
                v-if="!item.isLoaded"
                class="loader-img"
                style="margin: auto"
              >
                <svg
                  width="45"
                  height="45"
                  viewBox="0 0 45 45"
                  xmlns="http://www.w3.org/2000/svg"
                  stroke="#fff"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    transform="translate(1 1)"
                    stroke-width="2"
                  >
                    <circle cx="22" cy="22" r="6" stroke-opacity="0">
                      <animate
                        attributeName="r"
                        begin="1.5s"
                        dur="3s"
                        values="6;22"
                        calcMode="linear"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="stroke-opacity"
                        begin="1.5s"
                        dur="3s"
                        values="1;0"
                        calcMode="linear"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="stroke-width"
                        begin="1.5s"
                        dur="3s"
                        values="2;0"
                        calcMode="linear"
                        repeatCount="indefinite"
                      />
                    </circle>
                    <circle cx="22" cy="22" r="6" stroke-opacity="0">
                      <animate
                        attributeName="r"
                        begin="3s"
                        dur="3s"
                        values="6;22"
                        calcMode="linear"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="stroke-opacity"
                        begin="3s"
                        dur="3s"
                        values="1;0"
                        calcMode="linear"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="stroke-width"
                        begin="3s"
                        dur="3s"
                        values="2;0"
                        calcMode="linear"
                        repeatCount="indefinite"
                      />
                    </circle>
                    <circle cx="22" cy="22" r="8">
                      <animate
                        attributeName="r"
                        begin="0s"
                        dur="1.5s"
                        values="6;1;2;3;4;5;6"
                        calcMode="linear"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </g>
                </svg>
              </div>

              <div class="d-none d-md-flex justify-md-center">
                <div
                  class="d-flex align-center justify-center"
                  style="gap: 1rem; padding: 12px"
                >
                  <div
                    v-for="(circle, index) in items"
                    :key="index"
                    style="
                      width: 20px;
                      height: 20px;
                      border: 2px solid #07f;
                      border-radius: 50px;
                    "
                    role="button"
                    :class="model === index ? 'circle-blue' : ''"
                    @click="model = index"
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col
              cols="2"
              sm="2"
              class="d-flex d-md-none"
              style="
                position: relative;
                z-index: 2;
                align-self: stretch;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: end;
              "
            >
              <div class="line-details-vertical-mobile"></div>
              <img
                v-for="(icon, j) in item.icons"
                :key="j"
                width="40"
                height="40"
                style="position: relative; margin-right: 0.5rem"
                :src="icon.icon_src"
              />
            </v-col>
            <v-col cols="8" sm="8" md="5" lg="5" class="py-5 px-0 px-md-12">
              <v-card class="grey--text" color="transparent" flat>
                <h3
                  class="text-justify font-weight-regular content-common-component"
                >
                  {{ item.content }}
                </h3>
                <h1 class="mt-6 name-title-proffesional">
                  {{ item.name }}
                </h1>
                <h4 class="font-weight-regular subtitle-proffesional-columbia">
                  {{ item.sub }}
                </h4>
              </v-card>
            </v-col>
            <v-col cols="2" class="d-flex d-md-none"></v-col>
            <v-col
              cols="12"
              sm="12"
              md="1"
              lg="1"
              class="d-none d-md-flex"
              style="
                position: relative;
                z-index: 2;
                align-self: stretch;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: end;
              "
            >
              <div class="line-details-vertical-home"></div>
              <img
                v-for="(icon, j) in item.icons"
                :key="j"
                width="100"
                height="100"
                style="position: relative; margin-right: 0.5rem"
                :src="icon.icon_src"
              />
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "HomePageSection3",
  data() {
    return {
      model: 0,
      mt: "40px",
      padding: "33px",
      // font_texto: "151% !important",
      // font_name: "361% !important",
      // font_sub: "125% !important",
      show: true,
      // width_container: "1600px !important;",
      // margin_btn_crousel:'',
      // margin_top_btn_crousel:'',
      items: [
        {
          content:
            " “Terminé mi carrera e inicié en el mundo de la Aviación. Hoy soy Tripulante de Cabina de una prestigiosa aerolínea”.",
          name: "Mitchell Collantes",
          isLoaded: false,
          sub: "Egresado de Aviación Comercial en Columbia y Tripulante de Cabina en SKY Airlines",
          src: require("@/assets/pages/home/carousel_photo2.webp"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/mitchell-collantes-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure-outline.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“Gracias a mi querida Columbia por haberme enseñado a amar la carrera de Aviación y sobre todo ayudarme a cumplir mi gran sueño de convertirme en tripulante de cabina, motivándome y potenciando mis habilidades siempre”.",
          name: "Katia Cayo",
          isLoaded: false,
          sub: "Egresado de Aviación Comercial en Columbia y Tripulante de Cabina en LATAM Airlines",
          src: require("@/assets/pages/home/carousel_photo2.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/katia-cayo-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure-outline.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“Le doy gracias a mis padres eternamente, por haber confiado en mí y matricularme en Columbia para estudiar esta bella profesión y haber cumplido mi sueño de ser Tripulante de cabina. Ya pasaron más de 6 años viviendo este sueño, porque para mí, volar no es un trabajo, es una pasión. Gracias Columbia por las puertas que se me abren día a día, y por querer que siempre sea la mejor”. ",
          name: "Nuria Rios",
          isLoaded: false,
          sub: "Egresado de Aviación Comercial en Columbia y Tripulante de Cabina en LATAM Airlines",
          src: require("@/assets/pages/home/carousel_photo3.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/nuria-rios-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure-outline.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“La base siempre es lo más importante y es por ello que, cuando decidí sumergirme en el mundo de la cocina, elegí a Columbia; no solo por la excelente calidad de docentes o su increíble infraestructura, sino porque me apoyaron desde el inicio de esta aventura. Puedo decir que soy feliz haciendo lo que hago”.",
          name: "Luis Romero",
          isLoaded: false,
          sub: "Egresado de Alta Cocina en Columbia y Chef en los restaurantes “Koi Mar Bar” y “Oku Sushi Ramen” en Trujillo",
          src: require("@/assets/pages/home/carousel_photo4.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/luis-romero-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure-outline.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“El instituto Columbia fue la pieza principal de mi profesión, no solo con la buena formación profesional teniendo los mejores maestros, sino también la solidez y compromiso de cada área en el instituto”.",
          name: "Annie Alvarado",
          isLoaded: false,
          sub: "Egresado de Alta Cocina en Columbia y Chef en el Restaurante “Les trois soleils de Montal” en Francia",
          src: require("@/assets/pages/home/carousel_photo5.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/annie-alvarado-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure-outline.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“Como egresado de Columbia puedo garantizar una formación realista a la hora de la verdad en los distintos restaurantes u hoteles del sector, me ha permitido desempeñar mi pasión en diferentes lugares y países”.",
          name: "Renato Valdivia",
          isLoaded: false,
          sub: "Egresado de Alta Cocina en Columbia y Chef en el Restaurante “Kanka” en Colombia",
          src: require("@/assets/pages/home/carousel_photo6.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/renato-valdivia-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure-outline.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“Si tú eres parte de esta carrera, te puedo decir que no eres lo que logras, sino lo que esperas”.",
          name: "Francisco Díaz",
          isLoaded: false,
          sub: "Egresado de Hotelería Internacional en Columbia y Bellboy en el área de front en el “Hotel B”",
          src: require("@/assets/pages/home/carousel_photo7.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/francisco-diaz-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“Al terminar mi carrera de Hotelería Internacional en Columbia, siento que me brindó las herramientas necesarias para desarrollarme en hoteles de prestigio. Recuerdo mucho los talleres que realizaba en Columbia. Para mí el servicio es más que una atención, es conectar con el cliente y hacerlo sentir importante”.",
          name: "Gina Litano",
          isLoaded: false,
          sub: "Egresada de Hotelería Internacional en Columbia y encargada del Rooftop en el “Hotel Iberostar”",
          src: require("@/assets/pages/home/carousel_photo8.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/gina-litano-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
        {
          content:
            "“Mi experiencia profesional en el rubro de alimentos y bebidas inicia cuando yo estudiaba en Columbia. Como parte de la formación práctica, visitamos hoteles y restaurantes. No tengan miedo de cumplir sus sueños, atrévanse a seguir creciendo con buena actitud y perseverancia”.",
          name: "Belen Acobo",
          isLoaded: false,
          sub: "Egresada de Hotelería Internacional en Columbia y jefe de Servicio en “Pitahaya Lounge”",
          src: require("@/assets/pages/home/carousel_photo9.png"),
          srcMobile: require("@/assets/pages/home/carouselsMobile/belen-acobo-mobile.png"),
          icons: [
            {
              icon_src: require("@/assets/icons/airplane-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/chef-outline.svg"),
              width: "50",
              height: "72",
            },
            {
              icon_src: require("@/assets/icons/structure.svg"),
              width: "50",
              height: "72",
            },
          ],
        },
      ],
    };
  },
  // mounted() {
  //   this.onResize()
  //   window.addEventListener('resize', this.onResize, { passive: true });
  //  },
  methods: {
    loading(item) {
      item.isLoaded = true;
      console.log(item);
    },
    // onResize() {
    //   if (window.innerWidth > 900 && window.innerWidth < 1500) {

    //     this.font_texto = "151% !important";
    //     this.font_name = "320% !important";
    //     this.font_sub = "125% !important";
    //     this.mt ="",
    //     this.padding =""
    //     this.show =true
    //     this.margin_btn_crousel="-10rem"
    //     this.margin_top_btn_crousel="-12rem"

    //   } else if (window.innerWidth < 1000){
    //     this.show =false

    //   }
    //   else if (window.innerWidth > 1500) {
    //     this.mt ="40px",
    //     this.padding ="33px"
    //     this.font_texto = "151% !important";
    //     this.font_name = "331% !important";
    //     this.font_sub = "125% !important";
    //     this.show =true
    //     this.margin_btn_crousel="-2.5rem"
    //     this.margin_top_btn_crousel="-4.5rem"
    //   }
    // },
    handleCarousel() {
      this.model += 1;
      if (this.model > this.items.length + 1) {
        this.model = 0;
      }
      // console.log(this.$refs.nextButton);

      // this.$refs.nextButton.click();
    },
  },
};
</script>

<style>
.v-carousel__item {
  height: 640px;
}

.theme--dark.v-btn--active::before {
  opacity: 2;
  color: #07f;
}

.v-carousel__controls {
  /* background: unset ;
  justify-content: unset ; */
  /* margin-left: 150px ; */
}

.mdi-circle::before {
  content: unset;
}

.v-carousel__controls__item {
  margin: 0 8px;
  color: #07f !important;
  border: 1px solid;
}
.v-window__prev,
.v-window__next {
  background-color: transparent;
  display: inline;
}
.v-application--is-ltr .v-window__next {
  /* right: unset ; */
  /* left: 0;
  margin-left: 586px; */
}

.v-window__next {
  background-color: transparent !important;
}

.v-carousel__controls {
  background-color: transparent !important;
}
.background-profesional-home {
  background-color: #f4f4f4;
}
.position-content-image {
  position: relative;
}

.circle-blue {
  background-color: #07f;
}
.name-title-proffesional {
  font-size: 2.8rem;
}
.subtitle-proffesional-columbia {
  font-size: 0.95rem;
}
.line-details-vertical-home {
  border: 1.5rem solid transparent;
  border-radius: 8px;
  background: linear-gradient(to right, #0b77ff, #0762d5, #7d389f, #aa36e3)
    border-box !important;
  position: absolute;
  top: 12px;
  bottom: 12px;
  right: 12px;
}

.line-details-vertical-mobile {
  border: 0.5rem solid transparent;
  border-radius: 8px;
  background: linear-gradient(to right, #0b77ff, #0762d5, #7d389f, #aa36e3)
    border-box !important;
  position: absolute;
  top: 12px;
  bottom: 12px;
  right: 12px;
}

.loader-img {
  width: 400px;
  height: 400px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 960px) {
  .name-title-proffesional {
    font-size: 1.8rem;
  }
  .subtitle-proffesional-columbia {
    font-size: 0.8rem;
  }
  .loader-img {
    width: 200px;
    height: 200px;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
